import Image_, {
  ImageLoaderProps,
  ImageProps as ImageProps_,
} from "next/image";
import { useState } from "react";
import { imgUrl } from "utils/constants";
import Overlay from "./Overlay";

const CDN_HOST = "https://assets.clamphook.com/";

const myLoader = ({ src }: { src: string }) => {
  if (/^https?:\/\//i.test(src)) return src;
  const path = src.startsWith("/") ? src.slice(1) : src;
  // Avoid double-segment: if path already starts with the bucket folder, use host only
  if (path.startsWith("clamphook-dynamic/") || path.startsWith("clamphook-static/")) {
    return CDN_HOST + path;
  }
  return imgUrl + path;
};
interface ImageProps {
  overlay?: boolean;
  cdn?: boolean;
}

export default function Image({
  overlay = false,
  cdn = true,
  className,
  ...props
}: ImageProps & ImageProps_) {
  const [showPreview, setShowPreview] = useState(false);
  return (
    <>
      <Image_
        loader={cdn ? myLoader : undefined}
        {...props}
        className={`object-scale-down ${className ? className : ""}`}
        onClick={() => setShowPreview(true)}
      />
      {overlay && (
        <Overlay show={showPreview} onHide={() => setShowPreview(false)}>
          <div className="relative  w-screen h-screen ">
            <Image_
              loader={cdn ? myLoader : undefined}
              {...props}
              width={undefined}
              height={undefined}
              layout="fill"
              objectFit="contain"
              onClick={() => setShowPreview(false)}
            />
            <div className="bottom-0 absolute left-0 w-full text-center my-10">
              <span className="bg-gray-800 text-white px-10 py-2 rounded-xl">
                {props.alt}
              </span>
            </div>
          </div>
        </Overlay>
      )}
    </>
  );
}
